import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getSubscriptionFlags } from '../utils/subscriptionFlags';
import type { SubscriptionFlags } from '../types';
import { useUser } from '@/queries/useUser';

export function useSubscriptionFlags(): SubscriptionFlags & { trialDays: number } {
    const [searchParams] = useSearchParams();
    const { user } = useUser();

    const flags = useMemo(() => {
        return getSubscriptionFlags(searchParams);
    }, [searchParams]);

    const trialDays = useMemo(() => {
        return user?.data?.referral_trial_days || flags.trial_days || 14;
    }, [user?.data?.referral_trial_days, flags.trial_days]);

    return {
        ...flags,
        trialDays,
    };
}
